import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';

interface Holding {
  id: number;
  name: string;
  weight: number;
}

interface HoldingsPayload {
  titleAr: string;
  titleEn: string;
  holdings: Holding[];
}

type HoldingsFilter = 'all' | 'active' | 'other';

@Component({
  selector: 'app-portfolio-holdings',
  templateUrl: './portfolio-holdings.component.html',
  styleUrls: ['./portfolio-holdings.component.scss']
})
export class PortfolioHoldingsComponent implements OnInit {

  holdings: Holding[] = [];
  filteredHoldings: Holding[] = [];
  selectedFilter: HoldingsFilter = 'active';
  maxWeight = 0;
  totalCount = 0;
  activeCount = 0;
  otherCount = 0;
  topHolding: Holding | null = null;
  searchTerm = '';
  loaded = false;

  filters: { value: HoldingsFilter; labelKey: string }[] = [
    { value: 'active', labelKey: 'PortfolioHoldings.FilterActive' },
    { value: 'other', labelKey: 'PortfolioHoldings.FilterOther' },
    { value: 'all', labelKey: 'PortfolioHoldings.FilterAll' }
  ];

  constructor(private http: HttpClient) { }

  ngOnInit(): void {
    this.http.get<HoldingsPayload>('assets/data/portfolio-holdings.json').subscribe(payload => {
      this.holdings = [...(payload.holdings || [])].sort((a, b) => {
        if (b.weight !== a.weight) {
          return b.weight - a.weight;
        }
        return a.name.localeCompare(b.name, 'ar');
      });
      this.totalCount = this.holdings.length;
      this.activeCount = this.holdings.filter(h => h.weight > 0).length;
      this.otherCount = this.totalCount - this.activeCount;
      this.topHolding = this.holdings.find(h => h.weight > 0) || null;
      this.maxWeight = this.topHolding?.weight || 1;
      this.loaded = true;
      this.applyFilter();
    });
  }

  setFilter(filter: HoldingsFilter): void {
    this.selectedFilter = filter;
    this.applyFilter();
  }

  onSearch(term: string): void {
    this.searchTerm = term || '';
    this.applyFilter();
  }

  barWidth(weight: number): number {
    if (!this.maxWeight) {
      return 0;
    }
    return Math.max(0, Math.min(100, (weight / this.maxWeight) * 100));
  }

  trackById(_: number, item: Holding): number {
    return item.id;
  }

  private applyFilter(): void {
    let list = this.holdings;

    if (this.selectedFilter === 'active') {
      list = list.filter(h => h.weight > 0);
    } else if (this.selectedFilter === 'other') {
      list = list.filter(h => h.weight === 0);
    }

    const q = this.searchTerm.trim().toLowerCase();
    if (q) {
      list = list.filter(h => h.name.toLowerCase().includes(q));
    }

    this.filteredHoldings = list;
  }

}
